export function getOrgIcon (nodeType, extType, root) {
  return nodeType === 'company'
    ? (
        root
          ? 'org-company-root'
          : (
              'org-company'
            )
      )
    : (
        extType === 'command'
          ? 'org-project-command'
          : (
              extType === 'project'
                ? 'org-project'
                : 'org-project-production'
            )
      )
}

const root = { eof: true }
const indexes = {}

export function appendChildNodes (parentId, childNodes, usePermittedOrgs) {
  const parent = parentId >= 0 ? indexes[parentId] : root

  if (!parent.childNodes) {
    parent.childNodes = []
    parent.eof = true
  }

  const nodes = []

  parent.eof = usePermittedOrgs || childNodes.length < 21
  if (!parent.eof) childNodes.pop()

  childNodes.forEach(node => {
    if (!indexes[node.id]) {
      indexes[node.id] = node
    }
    parent.childNodes.push(node)
    nodes.push({ ...node })
  })
  return {
    nodes,
    eof: parent.eof
  }
}

export function getChildNodes (parentId) {
  const parent = parentId >= 0 ? indexes[parentId] : root
  return {
    nodes: parent.childNodes?.map(node => ({ ...node })),
    eof: parent.eof
  }
}

export function orgNodeDatas (datas) {
  if (datas) {
    Object.assign(root, datas.root)
    Object.assign(indexes, datas.indexes)
  } else return { root, indexes }
}
